import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { initializeLaunchDarkly } from 'ui';
import { enableMockServiceWorker } from '@shared/libs/msw';
import { enableProLicenseMUI } from '@shared/libs/MUI/index.ts';
import { initializeSentry } from '@shared/libs/sentry';
import { App } from './App.tsx';

initializeSentry();
enableMockServiceWorker();
enableProLicenseMUI();

const LDProvider = await initializeLaunchDarkly(
  import.meta.env.VITE_APP_LAUNCHDARKLY_ID,
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <LDProvider>
      <App />
    </LDProvider>
  </StrictMode>,
);
